import React, { useState, useRef, useEffect } from "react";

const TimelineSlider = ({
  initialPosition = 50,
  onPositionChange,
  thumbColor = "#000000",
  thumbHoverColor = "#333333",
  thumbActiveColor = "#242424",
  trackFillColor = "#242424", // 🔥 NEW: Fill color from left to thumb
  trackBaseColor = "#C9C9C9", // Base track color
}) => {
  const [position, setPosition] = useState(initialPosition);
  const [isDragging, setIsDragging] = useState(false);
  const trackRef = useRef(null);
  const thumbRef = useRef(null);

  const handleDragStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
    document.addEventListener("mousemove", handleDrag);
    document.addEventListener("mouseup", handleDragEnd);
    document.addEventListener("touchmove", handleTouchDrag, { passive: false });
    document.addEventListener("touchend", handleDragEnd);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    document.removeEventListener("mousemove", handleDrag);
    document.removeEventListener("mouseup", handleDragEnd);
    document.removeEventListener("touchmove", handleTouchDrag);
    document.removeEventListener("touchend", handleDragEnd);
  };

  const handleDrag = (e) => {
    if (!trackRef.current) return;
    const rect = trackRef.current.getBoundingClientRect();
    const clientX = e.clientX || (e.touches && e.touches[0]?.clientX);
    let newPos = ((clientX - rect.left) / rect.width) * 100;
    newPos = Math.max(0, Math.min(100, newPos));
    setPosition(newPos);
    onPositionChange?.(newPos);
  };

  const handleTouchDrag = (e) => {
    e.preventDefault();
    handleDrag(e);
  };

  const handleTrackClick = (e) => {
    if (!trackRef.current || isDragging) return;
    const rect = trackRef.current.getBoundingClientRect();
    let newPos = ((e.clientX - rect.left) / rect.width) * 100;
    newPos = Math.max(0, Math.min(100, newPos));
    setPosition(newPos);
    onPositionChange?.(newPos);
  };

  useEffect(() => {
    setPosition(initialPosition);
  }, [initialPosition]);

  return (
    <div
      ref={trackRef}
      className="relative w-full h-1 rounded-full cursor-pointer shadow-sm hover:shadow-md transition-all duration-200 select-none "
      style={{ backgroundColor: trackBaseColor }}
      onClick={handleTrackClick}
    >
      {/* 🔥 PROGRESSIVE FILL - Fills from left to thumb position */}
      <div
        className="absolute top-0 left-0 h-full rounded-full  transition-all duration-200"
        style={{
          width: `${position}%`,
          backgroundColor: trackFillColor,
          transition: isDragging
            ? "none"
            : "width 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      />

      {/* Thumb */}
      <div
        ref={thumbRef}
        className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 !w-3 !h-3 aspect-square rounded-full  transition-all duration-150 cursor-grab active:cursor-grabbing z-1 group bg-[#242424] "
        style={{
          left: `${position}%`,
          backgroundColor: isDragging ? thumbActiveColor : thumbHoverColor,
          transition: isDragging
            ? "none"
            : "left 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.15s ease",
        }}
        onMouseDown={handleDragStart}
        onTouchStart={handleDragStart}
      >
        <div className="relative">
          <p className="text-center left-1/2 -translate-x-1/2 text-[#242424] text-[12px] absolute whitespace-nowrap bottom-[115%]">
            2025-00-00
          </p>
        </div>
      </div>
    </div>
  );
};

export default TimelineSlider;
